import { generateUtilityClass, generateUtilityClasses } from '../className';
export function getFormHelperTextUtilityClass(slot) {
  return generateUtilityClass('JoyFormHelperText', slot);
}
const formHelperTextClasses = generateUtilityClasses('JoyFormHelperText', ['root']);
export default formHelperTextClasses;